import StockPage from "@/pages/stock/stock-page";
import { route } from "../utils";
import { RouteType } from "../types";

// Define routes with semantic names - single source of truth
export const inventoryRoutes: Record<string, RouteType> = {
  stocks: route("/stocks", StockPage),
};
